import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { BulkImportsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createBulkImport = (data, redirect = undefined): any => action(types.CREATE_BULK_IMPORT_REQUESTED, { data, redirect });

export const updateBulkImport = (data): any => action(types.UPDATE_BULK_IMPORT_REQUESTED, data);

export const deleteBulkImport = (bulkImportId): any => action(types.UPDATE_BULK_IMPORT_REQUESTED, bulkImportId);

export const getBulkImport = (bulkImportId): any => action(types.GET_BULK_IMPORT_REQUESTED, bulkImportId);

export const getAllBulkImports = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_BULK_IMPORTS_REQUESTED, {
  pagination,
  compile,
});

export const selectBulkImport = (bulkImportId): any => action(types.SELECT_BULK_IMPORT_REQUESTED, {
  currentBulkImportId: bulkImportId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createBulkImportPending: (payload): any => action(types.CREATE_BULK_IMPORT_PENDING, payload),
  createBulkImportSuccess: (response): any =>
  // const currentBulkImport = response.entities.bulkImports[response.result];
  // history.push(`/payment/${currentBulkImport.paymentCollection.id}/review`);
    action(types.CREATE_BULK_IMPORT_SUCCESS, {
      bulkImportsById: response.entities.bulkImports,
      currentBulkImportId: response.result,
    }),
  createBulkImportFailed: (error): any => action(types.CREATE_BULK_IMPORT_FAIL, { backendErrors: error }),
  updateBulkImportPending: (payload): any => action(types.UPDATE_BULK_IMPORT_PENDING, payload),
  updateBulkImportSuccess: (response): any => action(types.UPDATE_BULK_IMPORT_SUCCESS, {
    bulkImportsById: response.entities.bulkImports,
    currentBulkImportId: response.result,
  }),
  updateBulkImportFailed: (error): any => action(types.UPDATE_BULK_IMPORT_FAIL, { backendErrors: error }),
  deleteBulkImportPending: (): any => action(types.UPDATE_BULK_IMPORT_PENDING, {}),
  deleteBulkImportSuccess: (response, userId): any =>
  // localStorage.set(userId, { currentBulkImportId: null });
  // history.push('/bulkImports');

    action(types.DELETE_BULK_IMPORT_SUCCESS, {
      currentBulkImportId: response,
    }),
  getBulkImportPending: (): any => action(types.GET_BULK_IMPORT_PENDING, {}),
  getBulkImportSuccess: (response): any => action(types.GET_BULK_IMPORT_SUCCESS, {
    bulkImportsById: response.entities.teamDataImports,
    currentBulkImportId: response.result,
  }),
  getBulkImportFailed: (error): any => action(types.GET_BULK_IMPORT_FAIL, { backendErrors: error }),
  deleteBulkImportFailed: (error): any => action(types.UPDATE_BULK_IMPORT_FAIL, { backendErrors: error }),
  getAllBulkImportsPending: (pagination): any => action(types.GET_ALL_BULK_IMPORTS_PENDING, { pagination }),
  getAllBulkImportsSuccess: (response, meta): any => action(types.GET_ALL_BULK_IMPORTS_SUCCESS, {
    bulkImportsById: response.entities.teamDataImports,
    bulkImportIds: response.result,
    meta,
  }),
  getAllBulkImportsFailed: (error): any => action(types.GET_ALL_BULK_IMPORTS_FAIL, { backendErrors: error }),
};

export default null;
